import Input from '@/ui/Input';

import type { ShortResponseElementProps } from './ShortResponse.types';

export function ShortResponse(props: ShortResponseElementProps) {
  const { element, onChange, preferenceId } = props;

  const { name, value, custom_field_id, description, required } = element.attrs?.data || {};

  if (!name || !custom_field_id) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <label htmlFor={custom_field_id} className="font-medium text-sm text-gray-900">
          {name}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        {description && <p className="text-xs text-gray-700 font-normal">{description}</p>}
      </div>
      <Input
        name={custom_field_id}
        defaultValue={value || ''}
        placeholder={name}
        onBlur={(e) => {
          const newValue = e.target.value.trim();
          if (newValue !== (value || '').trim()) {
            onChange(newValue, preferenceId);
          }
        }}
        className="w-full px-3 py-2 !text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      />
    </div>
  );
}
